import { useEffect, useRef, useState } from 'react'
import { Button, Form, Modal, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import DynamicForm from './DynamicForm';
import { regexPatterns } from '../utils/regexUtils';
import { useCatalogs } from '../../hooks/useCatalogs';
import { getUserData, getUserInfoByTransactionAndOTPValid ,saveUserData} from '../../services/';
import { properties } from '../../utils/Properties_es';

export default function PersonalDataForm({ onValidate, data, updateData }) {
    const navigate = useNavigate();
    const { catalogs, loading } = useCatalogs();
    const { provinceBefore } = useState("");
    const { id } = useParams();

    const initialForm = {
        typeId: "",
        name: "",
        lastName: "",
        secondLastName: "",
        identification: "",
        nationality: "",
        country: "",
        date: "",
        profession: "",
        occupation: "",
        civilStatus: "",
        province: "",
        canton: "",
        distrito: "",
        barrio: "",
        address: "",
        phone: "",
        phoneHome: "",
        phoneWork: "",
        schooling: "",
        email: "",
        house: "",
        houseSide: "",
        houseColor: ""
    }
    const mapResponseToForm = (data) => {
        return {
            typeId: String(data.identificationType || ""),
            name: `${data.firstName || ""} ${data.secondName || ""}`.trim(),
            lastName: data.lastName1 || "",
            secondLastName: data.lastName2 || "",
            identification: data.identification || "",
            nationality: data.citizenship || "",
            country: data.countryOfResidence || "",
            date: data.dateOfBirth ? formatDate(data.dateOfBirth) : "",
            address: data.addressLine1 || "",
            phone: String(data.phoneMobile || ""),
            phoneHome: String(data.phoneHome || ""),
            phoneWork: String(data.phoneOffice || ""),
            schooling: data.degreeLevel || "",
            email: data.eMail || ""
        };
    };
    const getProvince = (value) => {
        return catalogs.provinces?.find(
            (item) => String(item.provinceCode) === String(value) || item.provinceName === value
        );
    };

    const getProvinceName = (value) => {
        const match = getProvince(value);
        return match?.provinceName || value || "";
    };

    const getCanton = (value, provinceCode) => {
        return catalogs.cantons?.find(
            (item) =>
                (String(item.cantonCode) === String(value) || item.cantonName === value) &&
                (provinceCode ? String(item.provinceCode) === String(provinceCode) : true)
        );
    };

    const getDistrict = (value, provinceCode, cantonCode) => {
        return catalogs.district?.find(
            (item) =>
                (String(item.districtCode) === String(value) || item.districtName === value) &&
                (provinceCode ? String(item.provinceCode) === String(provinceCode) : true) &&
                (cantonCode ? String(item.cantonCode) === String(cantonCode) : true)
        );
    };

    const getNeighborhood = (value, provinceCode, cantonCode, districtCode) => {
        return catalogs.neighborhoods?.find(
            (item) =>
                (String(item.neighborhoodCode) === String(value) || item.neighborhoodName === value) &&
                (provinceCode ? String(item.provinceCode) === String(provinceCode) : true) &&
                (cantonCode ? String(item.cantonCode) === String(cantonCode) : true) &&
                (districtCode ? String(item.districtCode) === String(districtCode) : true)
        );
    };

    const getCantonName = (value, provinceCode) => {
        const cantonMatch = getCanton(value, provinceCode);
        return cantonMatch?.cantonName || value || "";
    };

    const getDistrictName = (value, provinceCode, cantonCode) => {
        const match = getDistrict(value, provinceCode, cantonCode);
        return match?.districtName || value || "";
    };

    const getNeighborhoodName = (value, provinceCode, cantonCode, districtCode) => {
        const match = getNeighborhood(value, provinceCode, cantonCode, districtCode);
        return match?.neighborhoodName || value || "";
    };

    const mapDtoToUser = (data) => {
        const provinceMatch = getProvince(data.province);
        const cantonMatch = getCanton(data.canton, provinceMatch?.provinceCode);
        const districtMatch = getDistrict(data.district, provinceMatch?.provinceCode, cantonMatch?.cantonCode);
        const neighborhoodMatch = getNeighborhood(
            data.neighborhood,
            provinceMatch?.provinceCode,
            cantonMatch?.cantonCode,
            districtMatch?.districtCode
        );

        return {
            profession: data.professionCode || "",
            professionName: data.professionDescription || "",
            occupation: data.occupationCode || "",
            civilStatus: data.maritalStatusCode?.toString() || "",
            province: provinceMatch?.provinceName || getProvinceName(data.province),
            canton: cantonMatch?.cantonName || getCantonName(data.canton, provinceMatch?.provinceCode),
            distrito: districtMatch?.districtName || getDistrictName(data.district, provinceMatch?.provinceCode, cantonMatch?.cantonCode),
            barrio: neighborhoodMatch?.neighborhoodName || getNeighborhoodName(data.neighborhood, provinceMatch?.provinceCode, cantonMatch?.cantonCode, districtMatch?.districtCode),
            house: data.house||"",
            houseSide: data.houseSide||"",
            houseColor: data.houseColor||"",
            address: data.address || "",
            schooling: data.educationLevel
        }
    };


    const formatDate = (dateStr) => {
        if (!dateStr || dateStr.length !== 8) return "";
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        return `${year}-${month}-${day}`;
    };

    const selectedProvinceCode = getProvince(data.province)?.provinceCode;

    const selectedCantonCode = getCanton(data.canton, selectedProvinceCode)?.cantonCode;

    const selectedDistrictCode = getDistrict(data.distrito, selectedProvinceCode, selectedCantonCode)?.districtCode;

    const fieldConfig = [
        [
            { key: "typeId", label: "Tipo de identificación", type: "select", options: catalogs.documents?.map(p => ({ key: p.identificationName, value: p.identificationCode })), isRequired: true, disabled: true },
            { key: "name", label: "Nombre", type: "text", isRequired: true, regex: regexPatterns.onlyLetters, disabled: true },
        ],
        [
            { key: "lastName", label: "Primer apellido", type: "text", isRequired: true, disabled: true },
            { key: "secondLastName", label: "Segundo apellido", type: "text", regex: regexPatterns.onlyLetters, disabled: true },
        ],
        [
            { key: "identification", label: "Identificación", type: "text", isRequired: true, regex: regexPatterns.onlyNumbers, disabled: true },
            { key: "nationality", label: "Nacionalidad", type: "text", isRequired: true, regex: regexPatterns.onlyLetters, disabled: true }
        ],
        [
            { key: "country", label: "País de nacimiento", type: "text", isRequired: true, regex: regexPatterns.onlyLetters, disabled: true },
            { key: "date", label: "Fecha de nacimiento", type: "date", isDivider: true, isRequired: true, disabled: true }
        ],
        [
            { key: "schooling", label: "Nivel de escolaridad", type: "select", options: catalogs.educations?.map(p => ({ key: p.catalogDescription, value: p.catalogCode })), isRequired: true },
            { key: "profession", label: "Profesión", type: "select", options: catalogs.professions?.map(p => ({ key: p.positionName, value: String(p.positionNumber) })), isRequired: true }
        ],
        [
            { key: "occupation", label: "Ocupación", type: "select", options: catalogs.occupations?.map(p => ({ key: p.occupationName, value: p.occupationNumber })), isRequired: true },
            { key: "civilStatus", label: "Estado civil", type: "select", options: catalogs.maritalStatus?.map(p => ({ key: p.description, value: p.maritalStatusCode })), isRequired: true }
        ],
        [
            { key: "province", label: "Provincia", type: "select", options: catalogs.provinces?.map(p => ({ key: p.provinceName, value: p.provinceName })), isRequired: true },
            { key: "canton", label: "Cantón", type: "select", options: catalogs.cantons?.filter(p => p.provinceCode === selectedProvinceCode).map(p => ({ key: p.cantonName, value: p.cantonName })), isRequired: true, disabled: !data.province }
        ],
        [
            { key: "distrito", label: "Distrito", type: "select", options: catalogs.district?.filter(p => p.cantonCode === selectedCantonCode && p.provinceCode === selectedProvinceCode).map(p => ({ key: p.districtName, value: p.districtName })), isRequired: true, disabled: !data.canton },
            { key: "barrio", label: "Barrio", type: "select", options: catalogs.neighborhoods?.filter(p =>  p.districtCode === selectedDistrictCode && p.cantonCode === selectedCantonCode &&  p.provinceCode === selectedProvinceCode).map(p => ({ key: p.neighborhoodName, value: p.neighborhoodName })), isRequired: true, disabled: !data.distrito }
        ],
        [
            { key: "house", label: "Número de casa", type: "text", isRequired: true, regex: regexPatterns.alphanumeric , maxCaracters: 10},
            { key: "houseSide", label: "Lado Casa", type: "select",options:[{ key: "Izquierda", value: "IZQ" },{ key: "Derecha", value: "DER" }], isDivider: true, isRequired: true }
        ],
         [
            { key: "houseColor", label: "Color", type: "text", isRequired: true, regex: regexPatterns.onlyLetters, maxCaracters: 20 },
             { key: "empty", type: "empty" }
        ],
        [
            { key: "address", label: "Dirección exacta", type: "text", isDivider: true, isRequired: true , maxCaracters: 90}
        ],
        [
            { key: "phone", label: "Celular", type: "text", isRequired: true, regex: regexPatterns.onlyNumbers, maxCaracters: 8 },
            { key: "phoneHome", label: "Teléfono de tu casa", type: "text", regex: regexPatterns.onlyNumbers, maxCaracters: 8 }
        ],
        [
            { key: "phoneWork", label: "Teléfono de tu trabajo", type: "number", regex: regexPatterns.onlyNumbers , maxCaracters: 8},
            { key: "email", label: "Correo electrónico", type: "email", isRequired: true, maxCaracters: 40}
        ]
    ]

    const isFetching = useRef(false);

    useEffect(() => {
        const getUserInfo = async () => {
            if (isFetching.current) return;
            isFetching.current = true;
            try {
                const response = await getUserInfoByTransactionAndOTPValid(id);
                const mappedData = mapResponseToForm(response);
                updateData(mappedData);

                 const responseB = await getUserData(id);
                const mappedDataD = mapDtoToUser(responseB);
                updateData(mappedDataD);
            } catch (error) {
                console.error("Error al obtener info del usuario: ", error);
                isFetching.current = false;
            }
        };


        if (!loading.address && (!data || !data.identification) && !isFetching.current) {
            getUserInfo();
           
        }
    }, [loading.address, id]);

    const [show, setShow] = useState(false);
    const handleOpen = () => setShow(true);
    const handleClose = () => setShow(false);
    const handleChange = (e) => {
        const { name, value, selectedIndex, options } = e.target;
        const selectedText =options? options[selectedIndex]?.text:"";
        const locationFields = ["profession"];
        if (provinceBefore !== "" && provinceBefore !== value && name === "province") {
            updateData({ "canton": "" })
            updateData({ "distrito": "" })
            updateData({ "barrio": "" })
        }
        updateData({ [name]: value });
         if (locationFields.includes(name)) {
            updateData({ 
                [name]: value, 
                [`${name}Name`]: selectedText // Esto crea provinceName, cantonName, etc.
            });
        }
    }
    const handleReset = () => {
        updateData(initialForm);
        setShow(false);
        onValidate(false);
    }
    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};
        fieldConfig.flat().forEach(field => {
            if (field.isRequired && !data[field.key]) {
                newErrors[field.key] = properties.general_field_required(field.label);
            }
        });

        // Validar teléfonos (6-15 caracteres)
        const phoneFields = {
            phone: properties.field_cellphone,
            phoneHome: properties.personal_field_phone_home,
            phoneWork: properties.personal_field_phone_work
        };
        Object.entries(phoneFields).forEach(([phoneField, fieldLabel]) => {
            if (data[phoneField]) {
                const phoneValue = String(data[phoneField]).trim();
                if (phoneValue.length < 6 || phoneValue.length > 15) {
                    newErrors[phoneField] = `${fieldLabel} debe tener entre 6 y 15 dígitos`;
                }
            }
        });

        // Validar emails
        if (data.email) {
            if (!regexPatterns.email.test(data.email)) {
                newErrors.email = `${properties.field_email} no es válido`;
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    const handleContinue = (e) => {
        e.preventDefault();
        const isValid = validateForm();
        if (isValid) {
            saveUser();
            onValidate(true);
            navigate(`/forms/${id}/commerce`);
        }
    }
    const saveUser = async () => {

        try {
            const response = await saveUserData(data, id);
            console.log("Datos guardados con éxito:", response.adminId);
        } catch (error) {
            console.error("Error al obtener info del usuario: ", error);
            isFetching.current = false;
        }
    };

    return (
        <>
            <Form>
                <div className='px-4 mx-2 div-divider pb-4'>
                    <div className='d-flex flex-column gap-1'>
                        <h5 className='fw-bold'>{properties.personal_title}</h5>
                        <span className='fw-bold'>{properties.general_required_fields}</span>
                    </div>
                    <DynamicForm fieldConfig={fieldConfig} formData={data} handleChange={handleChange} errors={errors} />
                </div>
                <Row className='pb-5 mb-5 form-actions-row'>
                    <div className='d-flex justify-content-between px-0 form-actions'>
                        <Button size='sm' variant='outline-primary' className='px-2 py-2 shadow rounded-0 btn-icon-text' onClick={handleOpen}>
                            <i className='bi bi-trash'></i> {properties.btn_clean_fields}
                        </Button>
                        <Button variant='primary' size='sm' className='px-5 py-2 shadow rounded-0 form-action-btn'
                            onClick={handleContinue}>
                            {properties.btn_continue}
                        </Button>
                    </div>
                </Row>
            </Form>
            <Modal show={show} onHide={handleClose} centered size='md'>
                <Modal.Header closeButton className='border-bottom-0 px-5 pt-5 pb-0'>
                    <Modal.Title className='fs-6 text-center d-flex justify-content-center align-items-center w-100'><strong>{properties.modal_clean_title}</strong></Modal.Title>
                </Modal.Header>
                <Modal.Body className='px-5 mx-5 mb-5 fs-6 pt-0'>

                    <div className='d-flex flex-column justify-content-center w-100 pb-3 gap-4 align-items-center'>
                        <span>{properties.modal_clean_warning} </span>
                        <div className='d-flex gap-3'>
                            <Button variant='outline-primary' className='rounded-0' onClick={handleClose}>
                                {properties.btn_keep_fields}
                            </Button>
                            <Button variant='danger' className='rounded-0' onClick={handleReset}>
                                {properties.btn_delete_fields}
                            </Button>
                        </div>
                    </div>

                </Modal.Body>

            </Modal>
        </>
    )
}
